import { Input, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { UserService } from '../service/user-service';
import { CheckUserVendorResponse } from '../models/check-user-vendor.response';
import { VendorTsService } from '../service/vendor/vendor.ts.service';
import { MenuPermission } from '../models/menu-permission';
import { AuthService } from '../service/frappe/auth.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styles: [`
        .disabled-menu {
            pointer-events: none;
            opacity: 0.5; /* Optional: You can adjust the opacity to visually indicate that the menu is disabled */
        }
    `]
})
export class AppMenuComponent implements OnInit {
    userFound: boolean = false;
    isGateKeeper?: boolean = false;
    isAdministrator?: boolean = false;
    user_roles: any;
    menuPermission?: MenuPermission;
    vendorCode: string | null = null;

    errorMessage?: string;

    model: any[] = [];

    constructor(public layoutService: LayoutService, private userService: UserService, private vendorService: VendorTsService,        private authService: AuthService // Inject AuthService
    ) { }

    ngOnInit() {
        this.userService.userFound$.subscribe(userFound => {
            this.userFound = userFound;
        });

        const userFoundString = localStorage.getItem('userFound');
        if (userFoundString !== null) {
            this.userFound = JSON.parse(userFoundString);
        } else {
            this.userFound = true;
        }

        this.checkIfVendor();
        this.getVendorCode(); // Call getVendorCode to fetch vendor code

    }

    checkIfVendor() {
        this.vendorService.checkIfVendor()
            .then(response => {
                let userDetails = new CheckUserVendorResponse().deserialize(response.message || {});
                this.isGateKeeper = userDetails.isGateKeeper
                this.user_roles = userDetails.roles
                this.menuPermission=userDetails.menuPermisstion
                if (this.user_roles.includes('Administrator')) {
                    this.isAdministrator = true
                }
                this.setupMenu();
                // this.updateMenu()
            }).catch(error => {
                this.errorMessage = error.message;
            });
    }

    // private updateMenu() {
    //     if (this.isGateKeeper&& !this.isAdministrator) {
    //         this.model.forEach(section => {
    //             if (section.label === 'Portal') {
    //                 section.items = section.items.filter((item: { label: string; }) => item.label !== 'Vendor Management' && item.label !== 'Order Management');
    //             }
    //         });
    //     }
    // }

    hasVendorManagement(item: any): boolean {
        return item.label === 'Vendor Management';
    }
    private getVendorCode() {
        this.authService.getLoggedInUser()
            .then(loggedInUser => {
                this.authService.getVendorCode(loggedInUser)
                    .then(response => {
                        if (response.message && response.message.length > 0) {
                            this.vendorCode = response.message[0].vendor_code;
                        } else {
                            console.error("Vendor code not found in response.");
                        }
                        this.setupMenu();
                    })
                    .catch(error => {
                        console.error("Error fetching vendor code:", error);
                    });
            })
            .catch(error => {
                console.error("Error fetching logged-in user:", error);
            });
    }

    private setupMenu() {
         const changeRequestMenuItem = {
            label: 'Change Request',
            icon: 'pi pi-fw pi-user-edit',
            visible: this.menuPermission?.is_change_request,
            routerLink: this.vendorCode ? ['/portal/vendor/change-request', this.vendorCode] : ['/portal/vendor/change-request']
        };

        this.model = [
            {
                label: 'Portal',
                items: [

                    { label: 'Dashboard', icon: 'fas fa-house-chimney', routerLink: ['/'],visible: this.menuPermission?.is_dashboard },
                    {
                        label: 'Vendor Management',
                        icon: 'fas fa-users',
                        visible: this.menuPermission?.is_vendor_management,
                        items: [
                            // {
                            //     label: 'Vendor Details',
                            //     icon: 'pi pi-fw pi-user',
                            //     routerLink: ['/portal/vendor/vendor-detail-by-id']
                            // },
                            {
                                label: 'Add Vendor Master',
                                icon: 'fas fa-user-plus',
                                routerLink: ['/portal/vendor/add-vendor-user'],
                                visible: this.menuPermission?.is_add_vendor_user
                            },
                            {
                                label: 'Add User Role',
                                icon: 'fas fa-user-plus',
                                routerLink: ['add-user-role'],
                                visible: this.menuPermission?.is_add_user_role
                            },
                            {
                                label: 'Add User Creation',
                                icon: 'fas fa-user-plus',
                                routerLink: ['add-user-creation'],
                                visible: this.menuPermission?.is_add_user_creation
                            },
                            {
                                label: 'Vendor Registration',
                                icon: 'fas fa-address-card',
                                routerLink: ['/portal/vendor/registration'],
                                visible: this.menuPermission?.is_vendor_registration
                            },
                            {
                                label: 'Add Vendor Black / Legal',
                                icon: 'fas fa-user-plus',
                                routerLink: ['/vendor-black-list'],
                                visible: this.menuPermission?.is_vendor_black_list
                            },
                            // ...(this.user_roles.includes('Administrator') || this.user_roles.includes('admin') ? [] : [
                                {
                                    label: 'Vendor Details',
                                    icon: 'fas fa-user-gear',
                                    routerLink: ['/portal/vendor/vendor-detail-by-id'],
                                    visible: this.menuPermission?.is_vendor_details
                                },
                                {
                                    label: 'Change Detail',
                                    icon: 'pi pi-fw pi-user-edit',
                                    routerLink: ['/change-detail'],
                                    visible: this.menuPermission?.is_change_detail,
                                },
                                {
                                    label: 'Change Detail History',
                                    icon: 'pi pi-fw pi-user-edit',
                                    routerLink: ['/change-detail-history'],
                                    visible: this.menuPermission?.is_change_detail_history,
                                },
                            // ])
                            // changeRequestMenuItem,
                            {
                                label: 'Approved Vendor List',
                                icon: 'pi pi-list',
                                routerLink: ['/approve-vendor-list'],
                                visible: this.menuPermission?.is_approve_vendor_list
                            },
                            {
                                label: 'Reject Vendor List',
                                icon: 'pi pi-list',
                                routerLink: ['/reject-vendor-list'],
                                visible: this.menuPermission?.is_reject_vendor_list
                            },
                            {
                                label: 'Vendor Query List',
                                icon: 'pi pi-list',
                                routerLink: ['/vendor-query-list'],
                                visible: this.menuPermission?.is_vendor_query_list
                            },
                            {
                                label: 'Vendor Black / Legal List',
                                icon: 'pi pi-list',
                                routerLink: ['/vendor-black-and-legal-list'],
                                visible: this.menuPermission?.is_vendor_black_and_legal
                            },
                            {
                                label: 'Pending Vendor List',
                                icon: 'pi pi-list',
                                routerLink: ['/pending-vendor-list'],
                                visible: this.menuPermission?.is_pending_vendor_list
                            },
                            {
                                label: 'Pending Review',
                                icon: 'pi pi-list',
                                routerLink: ['/pending-review'],
                                visible: this.menuPermission?.is_pending_review
                            },
                            {
                                label: 'Pending Change Approval',
                                icon: 'pi pi-list',
                                routerLink: ['/pending-change-request'],
                                visible: this.menuPermission?.is_pending_change_request
                            },

                        ]
                    },
                    {
                        label: 'Order Management',
                        icon: 'fas fa-inbox',
                        visible: this.menuPermission?.is_order_management,
                        items: [
                          {
                            label: 'Upload Invoice',
                            icon: 'pi pi-fw pi-cloud-upload',
                            routerLink: ['/upload-invoice'],
                          },
                            {
                                label: 'Purchase Order',
                                icon: 'fas fa-boxes-stacked',
                                routerLink: ['/view-purchase-order'],
                                visible: this.menuPermission?.is_purchase_order
                            },
                            {
                                label: 'Schedule',
                                icon: 'fas fa-calendar-days',
                                routerLink: ['/portal/order/schedule'],
                                visible: this.menuPermission?.is_schedule

                            },
                            {
                                label: 'Shipment',
                                icon: 'fas fa-truck-fast',
                                routerLink: ['/portal/order/shipment'],
                                visible: this.menuPermission?.is_shipment,

                            },
                            {
                                label: 'Goods Receipt',
                                icon: 'fas fa-receipt',
                                routerLink: ['/gr'],
                                visible: this.menuPermission?.is_goods_receipt
                            },
                            {
                                label: 'Goods Receipt Line Item',
                                icon: 'fas fa-receipt',
                                routerLink: ['/gr-line-item'],
                                visible: this.menuPermission?.is_gr_line_item
                            },
                            {
                                label: 'Invoice Receipt',
                                icon: 'fas fa-file-invoice-dollar',
                                routerLink: ['/ir'],
                                visible: this.menuPermission?.is_invoice_receipt
                            },
                            {
                                label: 'Payment',
                                icon: 'fas fa-money-bill-wave',
                                routerLink: ['/portal/payment/view-payment'],
                                visible: this.menuPermission?.is_payment
                            },
                            {
                                label: 'Reconciliation',
                                icon: 'fas fa-money-bill-wave',
                                routerLink: ['view-reconciliation'],
                                visible: this.menuPermission?.is_reconciliation
                            },
                        ]
                    },
                       {
                        label: 'Gate Management',
                        icon: 'pi pi-fw pi-truck',
                        visible: this.menuPermission?.is_gate_management,
                        items: [
                          {
                            label: 'Upload Invoice',
                            icon: 'pi pi-fw pi-cloud-upload',
                            routerLink: ['/upload-invoice'],
                            visible: this.menuPermission?.is_upload_invoice
                          },
                            {
                                label: 'Token',
                                icon: 'pi pi-fw pi-ticket',
                                routerLink: ['/token'],
                                visible: this.menuPermission?.is_token

                            },
                            {
                                label: 'Gate In',
                                icon: 'pi pi-fw pi-directions',
                                routerLink: ['/gate-in'],
                                visible: this.menuPermission?.is_gate_in

                            },
                            {
                                label: 'Gate Out',
                                icon: 'pi pi-fw pi-directions-alt',
                                routerLink: ['/gate-out'],
                                visible: this.menuPermission?.is_gate_out

                            },
                            {
                                label: 'Visitor Pass In',
                                icon: 'pi pi-fw pi-credit-card',
                                routerLink: ['/visitor-pass'],
                                visible: this.menuPermission?.is_visitor_pass

                            },
                            {
                                label: 'Visitor Pass Out',
                                icon: 'pi pi-fw pi-credit-card',
                                routerLink: ['/visitor-gate-out-pass'],
                                visible: this.menuPermission?.is_visitor_gate_out_pass

                            }
                        ]
                    },
                ]
            },

            // {
            //     label: 'Reports',
            //     items: [
            //         { label: 'PO Report', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
            //         { label: 'Schedule Report', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
            //         { label: 'Shipment Report', icon: 'pi pi-fw pi-bookmark', routerLink: ['/uikit/floatlabel'] }
            //     ]
            // }
        ];
        // if (this.user_roles.includes('Administrator') || this.user_roles.includes('admin')) {
        //     this.model[0].items[1].items.unshift({
        //         label: 'Vendor List',
        //         icon: 'pi pi-fw pi-list',
        //         routerLink: ['/portal/vendor/list']
        //     });
        // }z
    }
}
